import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { showMessage } from "store/misc/messageSlice";
import authService from "../services/authService";
const initialState = {
	accessToken: null,
	isSubmitting: false,
};

export const loginWithEmailAndPassword = createAsyncThunk(
	"auth/loginWithEmailAndPassword",
	async (login, { dispatch }) => {
		try {
			dispatchEvent(setSubmitting(true));
			const accessToken = await authService.signInWithEmailAndPassword(login);
			return accessToken;
		} catch (error) {
			console.error(error);
			dispatch(
				showMessage({
					variant: "error",
					message: "Error occurred while connecting corksy account",
				})
			);
		} finally {
			dispatchEvent(setSubmitting(false));
		}
	}
);

const authSlice = createSlice({
	name: "authentication",
	initialState,
	reducers: {
		setSubmitting: (state, action) => {
			state.isSubmitting = action.payload;
		},
	},
	extraReducers: {
		[loginWithEmailAndPassword.fulfilled]: (state, action) => {
			state.accessToken = action.payload;
		},
	},
});

export const { setSubmitting } = authSlice.actions;

export default authSlice.reducer;
